/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessRequestUpdateAccessRequest
 */
export interface AccessRequestUpdateAccessRequest {
    /**
     * 
     * @type {any}
     * @memberof AccessRequestUpdateAccessRequest
     */
    assignedRoleId?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestUpdateAccessRequest
     */
    assignedPermissionId?: any | null;
}

/**
 * Check if a given object implements the AccessRequestUpdateAccessRequest interface.
 */
export function instanceOfAccessRequestUpdateAccessRequest(value: object): value is AccessRequestUpdateAccessRequest {
    return true;
}

export function AccessRequestUpdateAccessRequestFromJSON(json: any): AccessRequestUpdateAccessRequest {
    return AccessRequestUpdateAccessRequestFromJSONTyped(json, false);
}

export function AccessRequestUpdateAccessRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestUpdateAccessRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'assignedRoleId': json['assignedRoleId'] === undefined ? undefined : json['assignedRoleId'] === null ? null : json['assignedRoleId'],
        'assignedPermissionId': json['assignedPermissionId'] === undefined ? undefined : json['assignedPermissionId'] === null ? null : json['assignedPermissionId'],
    };
}

export function AccessRequestUpdateAccessRequestToJSON(json: any): AccessRequestUpdateAccessRequest {
    return AccessRequestUpdateAccessRequestToJSONTyped(json, false);
}

export function AccessRequestUpdateAccessRequestToJSONTyped(value?: AccessRequestUpdateAccessRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignedRoleId': value['assignedRoleId'],
        'assignedPermissionId': value['assignedPermissionId'],
    };
}

